import { object, string, array } from "yup";

export const getValidationSchema = (t) =>
  object().shape({
    office: string().required(t("general.validation.selectOffice")),
    poi: string().required(t("general.validation.selectPosition")),
    daysAvailable: array().required(t("general.validation.selectDays")),
    timesAvailable: array().required(t("general.validation.selectDays")),
    startDate: string()
      .min(8, t("general.validation.dateFormat"))
      .required(t("general.validation.startDateRequired")),
    validLicense: string().required(t("common.required")),
    carAndIns: string().required(t("common.required")),
  });

// Place names (office names and their city sub-lists) stay verbatim and are
// not translated.
export const getOffices = (t) => [
  {
    name: "HomeChoice of the Triangle",
    locationOffices: [
      "Raleigh/Durham",
      "Cary",
      "Fuquay Varina",
      "Garner",
      "Apex",
    ],
  },
  {
    name: "HomeChoice of the Sandhills",
    locationOffices: [
      "Southern Pines",
      "Pinehurst",
      "Aberdeen",
      "Sanford",
      "Fayetteville",
      "Pine Bluff",
      "Rockingham",
    ],
  },
  {
    name: "HomeChoice of Eastern Carolina",
    locationOffices: [
      "Goldsboro",
      "Kinston",
      "Pikeville",
      "Smithfield",
      "Greenville",
    ],
  },
];

// `value` is the original string sent to / matched against the backend; only
// `label` is translated for display.
export const getPositions = (t) => [
  { value: "Personal Care Aide", label: t("general.positions.pca") },
  { value: "Certified Nurse Aide", label: t("general.positions.cna") },
  { value: "Registered Nurse", label: t("general.positions.rn") },
  { value: "Office Worker", label: t("general.positions.officeWorker") },
  { value: "Supervisor in Charge", label: t("general.positions.supervisor") },
  { value: "Med Tech", label: t("general.positions.medTech") },
  { value: "Housekeeper", label: t("general.positions.housekeeper") },
  {
    value: "Resident Care Coordinator",
    label: t("general.positions.residentCareCoordinator"),
  },
  { value: "Transportation", label: t("general.positions.transportation") },
  {
    value: "Activities Director",
    label: t("general.positions.activitiesDirector"),
  },
  { value: "Kitchen Staff", label: t("general.positions.kitchenStaff") },
  { value: "Maintenance", label: t("general.positions.maintenance") },
  { value: "Dietary", label: t("general.positions.dietary") },
];

export const getDays = (t) => [
  { value: "Monday", label: t("general.days.monday") },
  { value: "Tuesday", label: t("general.days.tuesday") },
  { value: "Wednesday", label: t("general.days.wednesday") },
  { value: "Thursday", label: t("general.days.thursday") },
  { value: "Friday", label: t("general.days.friday") },
  { value: "Saturday", label: t("general.days.saturday") },
  { value: "Sunday", label: t("general.days.sunday") },
];

export const getTimeSlots = (t) => [
  { value: "12:00am - 4:00am", label: t("general.timeSlots.slot1") },
  { value: "4:00am - 8:00am", label: t("general.timeSlots.slot2") },
  { value: "8:00am - 12:00pm", label: t("general.timeSlots.slot3") },
  { value: "12:00pm - 4:00pm", label: t("general.timeSlots.slot4") },
  { value: "4:00pm - 8:00pm", label: t("general.timeSlots.slot5") },
  { value: "8:00pm - 12:00am", label: t("general.timeSlots.slot6") },
];

export const getLanguages = (t) => [
  { value: "English", label: t("general.languages.english") },
  { value: "Spanish", label: t("general.languages.spanish") },
  { value: "Chinese", label: t("general.languages.chinese") },
  { value: "Tagalog", label: t("general.languages.tagalog") },
  { value: "Vietnamese", label: t("general.languages.vietnamese") },
  {
    value: "French/French Creole",
    label: t("general.languages.frenchCreole"),
  },
  { value: "Arabic", label: t("general.languages.arabic") },
  { value: "Korean", label: t("general.languages.korean") },
  { value: "Russian", label: t("general.languages.russian") },
  { value: "German", label: t("general.languages.german") },
  { value: "Other", label: t("general.languages.other") },
];
